<template>
    <div class="max-h-screen h-screen fixed top-0 w-full z-50 overflow-hidden flex justify-center items-center flex-col flex-wrap">
        <BackgroundOverlay />
        <transition name="slide">
            <div
                v-if="show"
                class="bg-white mx-auto max-h-[80%] md:h-auto flex justify-center items-center flex-col overflow-hidden rounded-2xl transition-all duration-500 transform"
                :class="width[size]"
            >
                <!-- Top-->
                <div
                    class="h-auto flex py-5 px-4 items-center w-full"
                    :class="{ 'border-gray-400 border-b': showHeaderDivider }"
                >
                    <div
                        class="flex-auto text-center text-[20px] font-medium"
                        :class="{'ml-[25px]': showCloseButton}"
                    >
                        {{ title }}
                    </div>
                    <div
                        v-if="showCloseButton"
                        class="flex justify-end"
                    >
                        <button
                            data-accuid="DialogBottom_Close"
                            @click="onClickCloseButton"
                        >
                            <img
                                src="@/assets/images/icons/close.svg"
                                loading="lazy"
                                alt="close"
                            >
                        </button>
                    </div>
                </div>
                <!-- /Top-->

                <div class="flex-1 overflow-hidden flex flex-col px-1">
                    <div class="overflow-y-scroll flex-1 pb-24 xl:pb-0">
                        <!-- @slot 彈跳視窗 body -->
                        <slot></slot>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import BackgroundOverlay from '@/components/BackgroundOverlay';
/**
 *  統一彈窗
 */
export default {
    name: 'DialogBottom',
    components: { BackgroundOverlay },
    props: {
        /**
         * 彈跳視窗標題
         */
        title: {
            type: String,
            default: '',
        },
        /**
         * 判斷是否需彈跳視窗關閉按鈕
         */
        showCloseButton: {
            type: Boolean,
            default: false,
        },
        /**
         * 判斷是否需彈跳視窗標題下方分隔線
         */
        showHeaderDivider: {
            type: Boolean,
            default: false,
        },
        /**
         * 彈窗寬度尺寸
         */
        size: {
            type: String,
            default: 's',
        }
    },
    emits: ['close'],
    data() {
        /**
         * @param {Boolean} show 判斷彈跳視窗開關
         */
        return {
            show: false,
            width: {
                s: 'md:max-w-[576px]',
                m: 'md:max-w-[672px]',
                l: 'md:max-w-[1024px]',
            }
        };
    },
    mounted() {
        // 彈跳視窗開啟
        this.show = true;

        // 使 body 元素的內容禁止滾動，彈跳視窗顯示時，防止使用者通過滾動背景頁面造成網頁重新整理
        document.body.classList.add('overflow-hidden');
    },
    beforeUnmount() {
        // 使 body 元素的內容允許滾動
        document.body.classList.remove('overflow-hidden');
    },
    methods: {
        /**
         *  關閉彈跳視窗
         * 
         *  @public
         */
        onClickCloseButton() {
            /**
             * 關閉彈跳視窗
             */
            this.$emit('close');
        },
    },
};
</script>
<style scoped>
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease;
}

.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */
 {
    transform: translateY(20px);
}
::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-button {
    background: transparent;
    border-radius: 4px;
}

::-webkit-scrollbar-track-piece {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #005BAC;
}

::-webkit-scrollbar-track {
    box-shadow: transparent;
}
</style>
